import { BlogWrapper } from "../../../../src/collections/blog/Blog.style.js";
import cblogo from "../../../../src/collections/blog/2020/2020-07-16-communitybridge-2020-teaching-service-meshes-to-be-compliant/cblogo.webp";
import smiLogo from "../../../../src/collections/blog/2020/2020-07-16-communitybridge-2020-teaching-service-meshes-to-be-compliant/smi.webp";
import * as React from 'react';
export default {
  BlogWrapper,
  cblogo,
  smiLogo,
  React
};